import { css } from 'styled-components';

export { codeMirrorThemeClass } from 'app/utils/codemirror/codemirrorSetup';

const MONO = `'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace`;

export const messageMarkdownStyles = css`
    & pre {
        margin: 4px 0;
        padding: 10px 12px;
        border-radius: 4px;
        background: ${({ theme }) => theme.material.colors.background.default};
        overflow-x: auto;
        white-space: pre;
        font-family: ${MONO};
        font-size: 12px;
        line-height: 1.35;
    }
    & pre p,
    & pre br {
        margin: 0;
        line-height: inherit;
    }
    & pre code,
    & pre code.cm-code {
        background: transparent;
        padding: 0;
        border: none;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        white-space: inherit;
    }
    & code:not(.cm-code) {
        font-family: ${MONO};
        font-size: 0.9em;
        padding: 1px 6px;
        border-radius: 4px;
        background: ${({ theme }) => theme.material.colors.background.default};
        border: 1px solid ${({ theme }) => theme.material.colors.background.divider};
    }
    & blockquote {
        margin: 4px 0;
        padding: 4px 8px;
        border-left: 3px solid ${({ theme }) => theme.material.colors.background.divider};
        background: ${({ theme }) => theme.material.colors.background.default};
        border-radius: 0 4px 4px 0;
        color: ${({ theme }) => theme.material.colors.text.secondary};
    }
    & blockquote p {
        margin: 0;
    }
`;
